import { Base } from "../../framework/base";
import { ListItems } from "../../framework/listItems";
import { IRiskAssessmentListItem, RiskAssessmentListItem } from "./riskAssessmentListItem";

export interface IRiskAssessmentListItems extends ListItems<IRiskAssessmentListItem> {
}

export class RiskAssessmentListItems extends ListItems<RiskAssessmentListItem> implements IRiskAssessmentListItems {
    constructor();
    constructor(obj: IRiskAssessmentListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, RiskAssessmentListItem);
    }
}